import { render, staticRenderFns } from "./tpa.vue?vue&type=template&id=8647c5b4&"
import script from "./tpa.vue?vue&type=script&lang=js&"
export * from "./tpa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports